import { render } from "./LottoOddsInfo.vue?vue&type=template&id=c2eee99a&scoped=true"
import script from "./LottoOddsInfo.vue?vue&type=script&lang=js"
export * from "./LottoOddsInfo.vue?vue&type=script&lang=js"

import "./LottoOddsInfo.vue?vue&type=style&index=0&id=c2eee99a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2eee99a"]])

export default __exports__